import { useEffect, useState } from 'react';

import { Skeleton } from '@chakra-ui/react';
import { L2_PATHS } from 'Deer/constants/routes';
import { PastCheckInIntent } from 'Deer/intent/CheckIns/PastCheckInIntent';
import { CheckInsIntentDropdown } from 'Deer/intent/CheckIns/components/CheckInsIntentDropdown';
import { CheckInsMetaFilter } from 'Deer/intent/CheckIns/components/CheckInsMetaFilter';
import { Layout } from 'Deer/intent/components/Layout/Layout';

import { useGetPastCheckInsHistory } from '../data';
import { CheckInsHistoryInstance } from '../types';

const PAST_CHECK_INS_BREADCRUMBS = {
  items: [
    {
      label: 'Me',
      to: L2_PATHS['my-data'].overview,
    },
  ],
  page: {
    label: 'Check-ins',
    to: '',
  },
};

export const PastCheckIn = () => {
  // State to track the currently selected check-in instance
  const [selectedCheckIn, setSelectedCheckIn] = useState<CheckInsHistoryInstance | null>(null);

  const {
    data: checkInsHistory,
    isLoading: isCheckInsHistoryLoading,
    isError: isCheckInsHistoryError,
  } = useGetPastCheckInsHistory();

  // Set the first check-in as selected when data is loaded and no check-in is selected
  useEffect(() => {
    if (checkInsHistory?.length && !selectedCheckIn) {
      setSelectedCheckIn(checkInsHistory[0]);
    }
  }, [checkInsHistory, selectedCheckIn]);

  if (isCheckInsHistoryError) return null;

  // Render either a loading skeleton or the meta filter component based on loading state
  const MetaFilter = isCheckInsHistoryLoading ? (
    <Skeleton w="311px" height="30px" mt="12px" borderRadius="9999px" />
  ) : (
    <CheckInsMetaFilter
      checkInsHistory={checkInsHistory}
      selectedCheckIn={selectedCheckIn}
      setSelectedCheckIn={setSelectedCheckIn}
    />
  );

  return (
    <Layout Filters={<CheckInsIntentDropdown breadcrumbs={PAST_CHECK_INS_BREADCRUMBS} MetaFilter={MetaFilter} />}>
      <PastCheckInIntent selectedCheckIn={selectedCheckIn} />
    </Layout>
  );
};
